import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { NavLink, Outlet, useParams } from 'react-router-dom';
import RenderWysiwyg from 'render-wysiwyg';
import { ProjectsEndpoints } from '../../../Routes/api/Endpoints';
import { apiUrlImg } from '../../../Routes/api/global_vars';
import { useModifyProjectImageMutation } from '../../../services/auth-services/AuthService';
import { useFetchProjectsQuery } from '../../../services/auth-services/TacheService';
import { formatDate } from '../../Utils/FormatDate';
import { menuDetailProjet } from '../../Utils/UtilsSidebar';

function ProjectsDetail({ pourcentage }) {
    const { slug } = useParams();
    const { data: projets, isLoading: loadingProject } = useFetchProjectsQuery(ProjectsEndpoints.getProjects, {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        skip: false
    });

    const project = projets?.find((proj) => proj.slug === slug);

    // State pour gérer l'image sélectionnée
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    const [modifyProjectImage, { isLoading }] = useModifyProjectImageMutation();

    // Gestion du changement de fichier (upload d'image)
    const handleImageChange = (e) => {
        const file = e.target.files[0];  // Récupère le premier fichier sélectionné
        if (file) {
            setSelectedImage(file);
            setPreviewImage(URL.createObjectURL(file));  // Génère un aperçu de l'image
        }
    };

    // Soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedImage) {
            alert("Veuillez sélectionner une image.");
            return;
        }

        // Préparation des données à envoyer
        const formData = new FormData();
        formData.append("image", selectedImage);

        try {
            // Appel de la mutation avec les données du projet et l'image
            await modifyProjectImage({ projectId: project?.id, formData }).unwrap();

            toast.success("Image mise à jour avec succès !");
            setSelectedImage(null);
            setPreviewImage(null);
        } catch (error) {
            console.error("Erreur lors de l'envoi de l'image:", error);
            toast.error("Échec de la mise à jour de l'image.");
        }
    };
    const handleCancelImgChange = () => {
        setSelectedImage(null);
        setPreviewImage(null);
    }

    // console.log(project);

    return (
        <div className='flex justify-center mt-4'>
            <div className='bg-white w-[95%] rounded '>
                <div className='header flex justify-between p-5'>
                    <div className='flex gap-2 items-center'>
                        <NavLink to="/client-dashboard/dashboard">
                            <FaArrowLeftLong />
                        </NavLink>
                        <h1 className='font-bold'>{project ? project?.titre : "Projet"}</h1>
                    </div>
                </div>
                <div className='content'>
                    <div className='flex flex-wrap justify-between p-5'>
                        <div className='w-full lg:w-1/2'>
                            <h3 className='text-sm'>Date de création: <span className='font-bold'>{project ? formatDate(project?.created_at) : "12/06/2024"}</span></h3>
                            <h3 className='text-sm'>Objectif: <span className='font-bold'>{project ? project?.objectif : "Objectifs"}</span></h3>
                            <h3 className='text-sm inline-flex gap-1'>Description:
                                <span className='font-bold'><RenderWysiwyg content={project?.description} /></span>
                            </h3>
                        </div>
                        <div className='w-full lg:w-2/5'>
                            <h3 className='text-xs mb-3'>Progression du projet</h3>
                            <div className='w-full'>
                                <div className="w-full bg-gray-200 rounded-full h-[8px]">
                                    <div className="bg-green-500 h-full rounded-full" style={{ width: `${pourcentage || 0}%` }}></div>
                                </div>
                            </div>

                            {/* Formulaire d'upload */}
                            <form className='mt-10' onSubmit={handleSubmit} >
                                <div className="flex items-center justify-center w-full">
                                    <label
                                        htmlFor="dropzone-file"
                                        style={{
                                            backgroundImage: `url(${previewImage ?? `${apiUrlImg}/${project?.image || 'default.jpg'}`})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                        }}
                                        className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-200 relative rounded-lg cursor-pointer"
                                    >
                                        <div className="flex flex-col items-center justify-center pt-5 pb-6 absolute inset-0 w-full h-full z-[1000]">
                                            <svg className="w-8 h-8 mb-4  text-white"
                                                aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                    d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                            </svg>
                                            <p className="mb-2 text-base text-white">
                                                <span className="font-semibold">Cliquez pour télécharger et modifier l'image</span>
                                            </p>
                                            <p className="text-sm text-white">Formats: SVG, PNG, JPG ou GIF (MAX. 20Mo)</p>
                                        </div>
                                        <input id="dropzone-file" type="file" className="hidden" onChange={handleImageChange} disabled={isLoading} />
                                        <div className='absolute bg-black/30 w-full inset-0 h-full rounded-lg'></div>
                                    </label>
                                </div>

                                {previewImage && (
                                    <div className="inline-flex gap-4">
                                        <button
                                            type="submit"
                                            className="mt-4 bg-orange text-white px-4 py-2 rounded-lg text-xs hover:bg-orange-700 transition"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? "Mise à jour..." : "Modifier l'image"}
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-4 bg-gray-400 text-white px-4 py-2 rounded-lg text-xs hover:bg-orange-700 transition"
                                            onClick={handleCancelImgChange}
                                        >
                                            Annuler
                                        </button>
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                    <div className='border-b p-5'>
                        <div className='flex gap-3 items-center w-2/4'>
                            {menuDetailProjet.map((elem, index) => (
                                <NavLink to={`${elem.path}/${project?.id}`}
                                    className={({ isActive }) =>
                                        `flex justify-center p-3 bg-whiteclear w-2/6 text-xs rounded-lg text-gray-700 ${isActive && "!bg-orange !text-white font-inter font-semibold"}`}
                                    key={index}
                                >
                                    {elem.text}
                                </NavLink>
                            ))}
                        </div>
                    </div>
                    <div className='bg-[#EFF2F6]'>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjectsDetail;
